import React from "react";
import { Col, Row } from "reactstrap";

const MoreDetails = () => {
  return (
    <div className="invOrderDetails">
      <div>
        <Row className="mb-3">
          <Col md="4">
            <div className="invHeadDetails">Product Name</div>
            <div className="inv-details">Lisinopril 10mg Tablet</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">NDC/UPC</div>
            <div className="inv-details">34981-3198-99</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Manufacturer</div>
            <div className="inv-details">McKessson</div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md="4">
            <div className="invHeadDetails">Order Quantity</div>
            <div className="inv-details">10BTL</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Package Size</div>
            <div className="inv-details">1x1000 EA/BTL</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Ship Quantity</div>
            <div className="inv-details">10BTL</div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md="4">
            <div className="invHeadDetails">Package Cost</div>
            <div className="inv-details">$ 89.50</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Unit Cost </div>
            <div className="inv-details">$ 895.000</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Exceptions</div>
            <div className="inv-details">-</div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md="4">
            <div className="invHeadDetails">Allow Substitutes </div>
            <div className="inv-details">Yes</div>
          </Col>
          <Col md="4"></Col>
          <Col md="4"></Col>
        </Row>
      </div>
    </div>
  );
};

export default MoreDetails;
